/**
 * Software 스토어 브랜드 심볼 — 시안 추출본(작성자 제공).
 *
 * ★리포에도 `meta-colored-icon`·`PicoIcon`·`vive-icon` 이 있지만 **시안 것과 다르다**
 * (색·굵기·박스). 이 파일은 시안 자산을 그대로 옮긴 것이고, 여기가 정본이다.
 *
 * `fill` 은 전부 `currentColor` 로 바꿔 호출처에서 색을 정한다 — 원본은 `black` 과
 * `#121619` 로 섞여 있었다(`docs/pitfalls.md` 아이콘 추출 규칙).
 *
 * 크기는 **호출처 반응형**이다: 모바일 32 · 데스크탑 60(시안 실측).
 */
type IconProps = { className?: string };

export function MetaStoreIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M50.6606 18.9343C47.989 14.7376 44.4996 12.5 40.8352 12.5C38.653 12.5 36.4851 13.5256 34.4743 15.3737C33.1153 16.6233 31.8527 18.2003 30.6831 19.8658C29.2419 17.9444 27.9026 16.4765 26.6026 15.3605C24.14 13.2396 21.7792 12.5 19.4059 12.5C15.3075 12.5 11.7342 15.3135 9.25908 19.3351C6.46791 23.8706 5 29.7441 5 35.3785C5 38.4781 5.58038 41.1974 6.76256 43.2694C8.21083 45.8138 10.5502 47.5 14.2485 47.5C17.3665 47.5 19.7345 46.0246 22.5078 42.1328C24.09 39.9102 24.8918 38.5627 28.0562 32.6497L29.6312 29.7083C29.7616 29.4637 29.8902 29.2246 30.0188 28.9856C30.1455 29.2039 30.2723 29.426 30.4009 29.65L34.885 37.5446C36.3922 40.2019 38.353 43.1565 40.028 44.822C42.2085 46.99 44.18 47.5 46.4068 47.5C46.9658 47.5 47.4908 47.4511 47.9801 47.3626C48.1765 47.3269 48.3676 47.2836 48.5516 47.2365C49.2927 47.0427 49.9498 46.751 50.5266 46.3934C50.6713 46.305 50.8106 46.2109 50.9445 46.113C51.4159 45.7724 51.8285 45.3885 52.1856 44.9801C52.5946 44.5134 52.9321 44.0147 53.2053 43.516C53.4178 43.1302 53.6125 42.7237 53.791 42.2965C54.0285 41.7263 54.2339 41.1165 54.4053 40.4635C54.4911 40.136 54.5678 39.7973 54.6357 39.4473C54.8732 38.2202 55 36.8483 55 35.2938C55 29.3206 53.5803 23.5318 50.6588 18.9362L50.6606 18.9343ZM25.3382 28.3025C23.7614 30.8544 21.4167 34.9269 19.4273 37.8269C16.9451 41.4459 15.6557 41.8147 14.2468 41.8147C13.1556 41.8147 12.0842 41.2953 11.3663 40.0721C10.8181 39.1367 10.4002 37.5936 10.4002 35.5799C10.4002 30.702 11.7127 25.6226 13.8575 22.2126C15.3736 19.8 17.1861 18.221 19.3184 18.221C21.9542 18.221 23.606 19.9581 24.8918 21.3958C25.5329 22.1147 26.4276 23.3022 27.4651 24.8586L25.34 28.3006L25.3382 28.3025ZM46.4051 41.8147C45.1961 41.8147 44.2657 41.3085 42.9371 39.6129C41.9049 38.2918 40.1388 35.4896 37.0369 30.0433L35.7511 27.785C34.835 26.1759 33.9653 24.7306 33.1331 23.4302C33.2814 23.1874 33.4296 22.9503 33.576 22.7207C35.9118 19.0604 37.9887 17.0091 40.5709 17.0091C42.9585 17.0091 45.1282 18.6727 46.8033 21.3958C49.1623 25.235 50.2338 30.6079 50.2338 35.4482C50.2338 38.845 49.4694 41.8147 46.4033 41.8147H46.4051Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PicoStoreIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M31.105 6.27607C17.9934 5.66738 6.88412 15.7924 6.27601 28.9014C5.66789 42.0104 15.7982 53.1301 28.895 53.7239C41.9918 54.3326 53.1159 44.2076 53.724 31.0986C54.3321 18.0044 44.2018 6.88475 31.105 6.27607ZM30.8232 12.3184C40.5827 12.7786 48.1323 21.0479 47.6725 30.8165C47.5538 33.3849 46.8864 35.8939 45.6998 38.1653L34.635 24.121C34.4719 23.928 34.3236 23.7201 34.1604 23.5271C30.8084 19.4593 25.8396 17.084 20.5742 17.0543H20.4259C19.5063 17.0543 18.5867 17.1285 17.6967 17.2621C21.1971 13.8772 25.9434 12.0809 30.8084 12.3184H30.8232ZM29.1768 47.6816C19.4173 47.2214 11.8677 38.9521 12.3275 29.1835C12.4017 27.4613 12.728 25.8134 13.2619 24.2694L13.3509 24.1952C18.5718 20.3649 25.8841 21.3596 29.8888 26.4518L38.1206 36.9034L42.5406 42.5152C39.0254 46.0485 34.1752 47.934 29.1917 47.6964L29.1768 47.6816ZM22.7397 31.4549C22.7397 31.4549 22.7842 31.3807 22.8138 31.3361L22.8583 31.2471C22.8583 31.2471 22.9177 31.1283 22.9473 31.0689V31.0392C23.5406 29.6437 22.888 28.0403 21.4938 27.4465C20.3814 26.9863 19.1058 27.298 18.3345 28.2185L18.3049 28.2482C18.3049 28.2482 18.2307 28.3521 18.1862 28.3966C18.112 28.5006 18.0379 28.6193 17.9786 28.7529L17.9489 28.7975C17.7709 29.1686 17.6819 29.5695 17.6819 29.9703C17.6819 31.4846 18.913 32.7168 20.4259 32.702C21.3603 32.702 22.2354 32.2121 22.7397 31.4252V31.4549Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ViveportStoreIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M38.3623 43.8184C35.727 44.6279 32.9123 45.0784 30.0053 45.0784C27.0983 45.0784 24.2819 44.6279 21.6484 43.8184C18.5602 42.8277 16.6513 39.7674 17.2871 36.6175C18.468 30.8561 21.4655 25.8144 25.7363 21.943C28.1887 19.6923 31.9142 19.6923 34.3667 21.943C38.5451 25.7247 41.5427 30.8544 42.8159 36.6175C43.361 39.7691 41.5444 42.9191 38.364 43.8184M53.3518 40.9377L35.7287 10.7809C35.1836 9.79023 34.1838 9.25 33.0935 9.25H27.0078C25.9174 9.25 24.9177 9.79023 24.3725 10.7809L6.65887 40.9377C6.11371 41.9284 6.11371 43.0986 6.65887 43.9979L9.74702 49.2191C10.2922 50.2098 11.2919 50.75 12.3823 50.75H47.5378C48.6282 50.75 49.6279 50.2098 50.1731 49.2191L53.2612 43.9979C53.897 43.0072 53.897 41.837 53.3518 40.9377Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AppStoreIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.3912 5C40.7259 7.9275 39.4991 10.8697 37.6764 12.9833C35.8536 15.0981 32.862 16.7407 29.9335 16.5237C29.5345 13.6541 31.0135 10.6601 32.7024 8.7895C34.5869 6.67713 37.7639 5.10115 40.3912 5ZM51.2392 41.6759C50.9262 41.5545 44.3167 38.9921 44.2447 31.5634C44.1867 25.3685 49.4148 22.3239 49.8635 22.0627C49.873 22.0571 49.8803 22.0529 49.8855 22.0498C46.8181 17.7487 42.0409 17.158 40.3391 17.0901C37.8526 16.8488 35.4403 17.7603 33.4703 18.5047C32.2196 18.9773 31.1471 19.3825 30.3473 19.3825C29.4548 19.3825 28.3521 18.9635 27.1149 18.4935C25.495 17.878 23.6443 17.1748 21.7329 17.2098C17.3008 17.2715 13.2175 19.6773 10.9326 23.4765C6.33321 31.1269 9.75859 42.4606 14.2409 48.6683C16.4343 51.7031 19.0488 55.1212 22.482 54.9967C24.0184 54.9389 25.1106 54.4933 26.2398 54.0325C27.5422 53.5012 28.894 52.9497 31.0334 52.9497C33.0773 52.9497 34.3697 53.4853 35.6124 54.0003C36.7992 54.492 37.9406 54.965 39.6478 54.9349C43.2046 54.8721 45.4624 51.8374 47.6379 48.7915C50.0733 45.3821 51.1235 42.0779 51.2413 41.7073C51.2452 41.6949 51.2481 41.6858 51.25 41.6801C51.25 41.6801 51.245 41.6781 51.2392 41.6759Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function GooglePlayStoreIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M7.5 8.06843V51.9293C7.50029 52.0244 7.52868 52.1174 7.58159 52.1965C7.6345 52.2756 7.70958 52.3373 7.79742 52.3739C7.88527 52.4105 7.98196 52.4203 8.07537 52.4022C8.16878 52.384 8.25476 52.3387 8.32252 52.2719L31.1601 30L8.32252 7.7258C8.25476 7.65899 8.16878 7.61367 8.07537 7.59553C7.98196 7.57739 7.88527 7.58723 7.79742 7.62383C7.70958 7.66042 7.6345 7.72213 7.58159 7.80122C7.52868 7.88032 7.50029 7.97327 7.5 8.06843Z"
        fill="currentColor"
      />
      <path
        d="M40.7355 20.8483L12.1001 5.07176L12.0822 5.06172C11.5889 4.79386 11.1202 5.46126 11.5242 5.84965L33.9712 27.3136L40.7355 20.8483Z"
        fill="currentColor"
      />
      <path
        d="M11.5255 54.1502C11.1193 54.5386 11.588 55.206 12.0835 54.9382L12.1014 54.9281L40.7346 39.1516L33.9702 32.6841L11.5255 54.1502Z"
        fill="currentColor"
      />
      <path
        d="M52.2965 27.2096L44.3 22.8057L36.7812 29.9997L44.3 37.1905L52.2965 32.7899C54.4716 31.5879 54.4716 28.4116 52.2965 27.2096Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Windows — 시안 추출본(작성자 제공). `fill` 은 `currentColor` 로 바꿨다. */
export function WindowsStoreIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M5.25 12.2576L25.482 9.5111L25.4933 28.963L5.26701 29.0817L5.25 12.2576ZM25.4706 31.2066L25.4876 50.6754L5.26701 47.9062V31.0766L25.4706 31.2066ZM27.9252 9.15507L54.7443 5.25V28.72L27.9195 28.9347V9.15507H27.9252ZM54.75 31.3874V54.75L27.9195 50.9749L27.8799 31.3422L54.75 31.3874Z"
        fill="currentColor"
      />
    </svg>
  );
}

/**
 * Download 버튼 안 아이콘 — 시안 `29889:102350`(Button) 의 `Icons/file_download` 18px.
 * 초판은 텍스트만 넣어 아이콘이 빠져 있었다.
 */
export function FileDownloadIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.43731 3V9.6224L5.99767 7.45458L5.25 8.29542L9 11.6276L12.75 8.29542L12.0023 7.45458L9.56269 9.6224V3H8.43731ZM3.375 11.25V13.5C3.375 14.2249 3.94367 14.8125 4.64516 14.8125H13.3548C14.0563 14.8125 14.625 14.2249 14.625 13.5V11.25H13.5363V13.5C13.5363 13.6036 13.4551 13.6875 13.3548 13.6875H4.64516C4.54495 13.6875 4.46371 13.6036 4.46371 13.5V11.25H3.375Z"
        fill="currentColor"
      />
    </svg>
  );
}
